@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../respond-to.scss';
@import '../../global-styles/index.scss';


.ciHeader {
  &-main-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;

  }

  &-accounts {
    display: block;
    position: relative;
    .ghf-text-button {
      font-size: 12px !important;
      padding: 0 8px;
      height: 40px;
      &:link, &:visited {
        color: $color-gray-slate-default;
      }
      &:hover {
        color: $color-blue-default;
        svg, path {
          fill: $color-blue-default;
        }
      }
    }
    &-btn {
      // must be above the z-index of 100, set for the .ciHeader-account-subMenu element in ci-accounts.scss
      z-index: 101;
      position: relative;
      line-height: 1.333;
      white-space: nowrap;
      &--isActive {
        color: $color-blue-default;
        background: $color-header-hover-blue;
        &:link, &:visited {
          color: $color-blue-default;
        }
        svg, path {
          fill: $color-blue-default;
        }
      }
    }
  }

}
@media only screen and (min-width: 1024px) {
.ciHeader-main {
  .ciHeader-main-actions {
      display: none;
    }
  }
}
